/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Form_MessageInputs */

const en_support_form_message = /** @type {(inputs: Support_Form_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can we help?`)
};

const id_support_form_message = /** @type {(inputs: Support_Form_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang bisa kami bantu?`)
};

/**
* | output |
* | --- |
* | "How can we help?" |
*
* @param {Support_Form_MessageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_form_message = /** @type {((inputs?: Support_Form_MessageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Form_MessageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_form_message(inputs)
	return en_support_form_message(inputs)
});